/* eslint-disable import/prefer-default-export */
import makeApiCall from './makeApiCall';

export const postPresentedvsCoverageChart = (params) =>
  makeApiCall(`/products/utilization/presented-coverage/graph`, 'POST', params);

export const postPresentedvsCoverageList = (params) =>
  makeApiCall(`/products/utilization/presented-coverage/list`, 'POST', params);

export const postPresentedvsCoverageExport = (params) =>
  makeApiCall(`/products/utilization/presented-coverage/report`, 'POST', params);

// PRODUCT TEAM PRESENTED

export const postProductTeamPresentedChart = (params) =>
  makeApiCall(`/products/utilization/product-team-presented/graph`, 'POST', params);

export const postProductTeamPresentedList = (params) =>
  makeApiCall(`/products/utilization/product-team-presented/list`, 'POST', params);

export const postProductTeamPresentedExport = (params) =>
  makeApiCall(`/products/utilization/product-team-presented/report`, 'POST', params);

// PRODUCT PRESENTED

export const postProductPresentedChart = (params) =>
  makeApiCall(`/products/utilization/product-presented/graph`, 'POST', params);

export const postProductPresentedList = (params) =>
  makeApiCall(`/products/utilization/product-presented/list`, 'POST', params);

export const postProductPresentedExport = (params) =>
  makeApiCall(`/products/utilization/product-presented/report`, 'POST', params);

// Product Presented Per Specialty

export const postProductPresentedPerSpecialtyChart = (params) =>
  makeApiCall(`/products/utilization/product-specialty-presented/graph`, 'POST', params);

export const postProductPresentedPerSpecialtyList = (params) =>
  makeApiCall(`/products/utilization/product-specialty-presented/list`, 'POST', params);

export const postProductPresentedPerSpecialtyExport = (params) =>
  makeApiCall(`/products/utilization/product-specialty-presented/report`, 'POST', params);

// PER GROUP

export const postPerGroupChart = (params) =>
  makeApiCall(`/products/utilization/product-group-presented/graph`, 'POST', params);

export const postPerGroupList = (params) =>
  makeApiCall(`/products/utilization/product-group-presented/list`, 'POST', params);

export const postPerGroupExport = (params) =>
  makeApiCall(`/products/utilization/product-group-presented/report`, 'POST', params);

// PER SEGMENT

export const postPerSegmentChart = (params) =>
  makeApiCall(`/products/utilization/product-presented-segments/graph`, 'POST', params);

export const postPerSegmenList = (params) =>
  makeApiCall(`/products/utilization/product-presented-segments/list`, 'POST', params);

export const postPerSegmenExport = (params) =>
  makeApiCall(`/products/utilization/product-presented-segments/report`, 'POST', params);

// DROPDOWN

export const postAgendaFilter = (params) =>
  makeApiCall(`/products/utilization/agenda/list`, 'POST', params);
